<template>
  <transition v-if="visible" name="fade">
    <div class="modal modal-mask" tabindex="-1" role="dialog" aria-hidden="true" aria-modal="true" @click.self="onClickOutsideModal">
      <div
        role="document"
        class="modal-dialog mx-auto d-flex flex-column justify-content-center"
        :class="extraClasses">
        <div class="modal-content">
          <i v-if="showCloseIcon" class="fa fa-close close-dialog" @click="$emit('close')"></i>
          <div id="modal-body" class="modal-body">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
/**
 * A simple stand-alone modal component
 * (entirely detached from the global modal manager in @components/shared/Modal.vue)
 *
 * Usage example:
 * <modal :visible="myVisibleVar" @close="myVisibleVar = false">
 *  <p>Contents of the modal</p>
 * </modal>
 *
 * .. and you can then control whether the modal should show/hide by modifying your `myVisibleVar` variable
 */
export default {
  name: 'modal',
  components: {
  },
  props: {
    // Use this to control when to show/hide the modal
    visible: {
      type: Boolean,
      required: true
    },
    showCloseIcon: {
      type: Boolean,
      required: false,
      default: true
    },
    closeOnClickOutsideModal: {
      type: Boolean,
      required: false,
      default: true
    },
    // Use this to customize the styling/size/alignment of the modal
    // Examples:
    // - `h-100 my-0` will center the modal
    // - `modal-dialog-l` or `modal-dialog-xl` will make it larger
    extraClasses: {
      type: String,
      required: false,
      default: ''
    }
  },
  watch: {
    visible (newVal) {
      if (newVal) {
        document.body.classList.add('modal-open')
      } else {
        document.body.classList.remove('modal-open')
      }
    }
  },
  methods: {
    onClickOutsideModal () {
      if (this.closeOnClickOutsideModal) {
        this.$emit('close')
      }
    }
  }
}
</script>
